export const enumRole = {
  SUPERUSER: 'Superuser',
  OUTLET: 'Outlet',
  MERCHANT: 'Owner',
};

export const handleRedirect = () => (window.location.href = '/dashboard');
